import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 180000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ht_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const p = window.location.pathname;
    const isPublic = p.startsWith("/q/") || p.startsWith("/play/") || p === "/login" || p === "/employee/login";
    if (err?.response?.status === 401 && !isPublic) {
      localStorage.removeItem("ht_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const auth = {
  login: (email, password) => api.post("/auth/login", { email, password }).then(r => r.data),
  empLogin: (emp_id, password) => api.post("/auth/employee-login", { emp_id, password }).then(r => r.data),
  universalLogin: (identifier, password) => api.post("/auth/universal-login", { identifier, password }).then(r => r.data),
  me: () => api.get("/auth/me").then(r => r.data),
  saveToken: (t) => localStorage.setItem("ht_token", t),
  clear: () => { localStorage.removeItem("ht_token"); localStorage.removeItem("ht_user"); },
  saveUser: (u) => localStorage.setItem("ht_user", JSON.stringify(u)),
  user: () => { try { return JSON.parse(localStorage.getItem("ht_user") || "null"); } catch { return null; } },
  token: () => localStorage.getItem("ht_token"),
};

export function fileUrl(storage_path) {
  if (!storage_path) return "";
  if (storage_path.startsWith("http")) return storage_path;
  return `${API}/files/${storage_path}?auth=${auth.token() || ""}`;
}
